import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock, ArrowRight } from 'lucide-react';
import { formatDateIST } from '@/utils/date';
import { IITH, SERIF } from '@/pages/landing/iithBrand';
import { formatDurationMinutes } from '@/modules/reception/formatVisitDuration';

/** Upcoming appointments snapshot on patient home. */
export default function PatientUpcomingList({ items = [], primary = IITH.saffron }) {
  return (
    <section className="mb-10 rounded-3xl border border-[#D5DEE8] bg-white p-5 sm:p-6 shadow-sm" data-testid="patient-upcoming">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <div>
          <h2 className="text-lg font-bold text-[#071B34]" style={{ fontFamily: SERIF }}>Upcoming visits</h2>
          <p className="text-xs text-[#7A8B9C]">Appointments & walk-ins still in progress</p>
        </div>
        <Link to="/patient/appointments" className="text-xs font-semibold inline-flex items-center gap-1" style={{ color: primary }}>
          View all <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
      {items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-[#D5DEE8] bg-[#F8FAFC] px-4 py-8 text-center">
          <CalendarClock className="h-7 w-7 mx-auto text-[#9AADBE]" />
          <p className="mt-2 text-sm text-[#5A6B7C]">No open appointments right now.</p>
          <Link
            to="/patient/appointments/book"
            className="mt-3 inline-flex text-sm font-semibold"
            style={{ color: primary }}
          >
            Book an OPD slot
          </Link>
        </div>
      ) : (
        <ul className="space-y-2.5">
          {items.map((a) => {
            const wait = formatDurationMinutes(a.wait_to_triage_minutes);
            return (
              <li key={a.id} className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-[#EEF2F7] px-3.5 py-3">
                <div>
                  <p className="text-sm font-semibold text-[#071B34]">
                    {a.date ? formatDateIST(a.date) : '—'}
                    {a.time ? ` · ${a.time}` : ''}
                  </p>
                  <p className="text-[12px] text-[#5A6B7C]">{a.doctor_name} · {a.visit_type}</p>
                </div>
                <div className="text-right">
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded-full border border-indigo-200 bg-indigo-50 text-indigo-900">
                    {a.status_label || a.status}
                  </span>
                  {wait ? (
                    <p className="text-[10px] text-[#7A8B9C] mt-1">Wait {wait}{a.wait_to_triage_open ? ' …' : ''}</p>
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
